import { Check, X } from "lucide-react";
import { site } from "../content";
import { Reveal, SectionHeading } from "./Reveal";

export default function Comparison() {
  return (
    <section id="comparativo" data-testid="comparison-section" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading
          chapter="09"
          eyebrow="Comparativo"
          title="Do improviso ao profissional."
          align="center"
          testId="comparison-heading"
        />

        <div className="relative mt-16 grid gap-6 lg:grid-cols-2">
          <span
            className="absolute left-1/2 top-1/2 z-10 hidden h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-gold/50 bg-ink font-display text-xs font-black tracking-widest text-gold shadow-[0_0_40px_rgba(252,172,4,0.25)] lg:flex"
            aria-hidden="true"
          >
            VS
          </span>

          <Reveal>
            <div
              data-testid="comparison-improvised"
              className="h-full rounded-3xl border border-white/10 bg-ink/60 p-9 backdrop-blur-xl md:p-11"
            >
              <h3 className="font-display text-lg font-extrabold uppercase tracking-wide text-bone/50">
                Métodos improvisados
              </h3>
              <ul className="mt-8 space-y-5">
                {site.comparison.improvised.map((item) => (
                  <li key={item} className="flex items-start gap-3.5 text-sm text-bone/45">
                    <X className="mt-0.5 h-4 w-4 shrink-0 text-red-400/70" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div
              data-testid="comparison-steamer"
              className="h-full rounded-3xl border border-gold/40 bg-gold/[0.05] p-9 shadow-[0_0_60px_rgba(252,172,4,0.08)] backdrop-blur-xl md:p-11"
            >
              <h3 className="font-display text-lg font-extrabold uppercase tracking-wide text-gold">
                Barber Steamer
              </h3>
              <ul className="mt-8 space-y-5">
                {site.comparison.steamer.map((item) => (
                  <li key={item} className="flex items-start gap-3.5 text-sm font-medium text-bone/85">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
